import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Constant} from '../util/constant';
import {catchError, retry} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class AppointmentTypeService {
    httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/json'})};

    constructor(private httpClient: HttpClient) {
    };

    deleteByIdAppointmentType(appointmentTypeId): Observable<string> {
        return this.httpClient.post<string>(
            Constant.BASE_URL + 'AppointmentType/deleteAppointmentType', {'appointmentTypeId': appointmentTypeId}, this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    countAppointmentType(appointmentType): Observable<number> {
        return this.httpClient.post<number>(Constant.BASE_URL + 'AppointmentType/count', {'appointmentType': appointmentType},
                                            this.httpOptions
        ).pipe(retry(3), catchError(Constant.handleError));
    }

    updateAppointmentType(appointmentType): Observable<string> {
        return this.httpClient.post<string>(
            Constant.BASE_URL + 'AppointmentType/updateAppointmentType', [appointmentType], this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    addAppointmentType(appointmentType): Observable<string> {
        return this.httpClient.post<string>(
            Constant.BASE_URL + 'AppointmentType/addAppointmentType', [appointmentType], this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    findAllAppointmentType(appointmentType, pageNo: number, itemsPerPage: number): Observable<string[]> {
        return this.httpClient.post<string[]>(
            Constant.BASE_URL + 'AppointmentType/findAllAppointmentType',
            {'appointmentType': appointmentType, 'pagination': {'pageNo': pageNo, 'itemsPerPage': itemsPerPage}}, this.httpOptions
        ).pipe(
            retry(3), catchError(Constant.handleError));
    }

}
